var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ENABLE_VALIDATION, formatValidationError, tryParseResponse, ValidationError } from '../../../../utils';
export function decodeNodesBulkApproveResponse(response, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.enableValidation, enableValidation = _c === void 0 ? ENABLE_VALIDATION : _c;
    return __awaiter(this, void 0, Promise, function () {
        var _d, status, data, _e, validateNodesBulkApproveAndUnenrollResponse, validateErrorResponse;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, tryParseResponse(response)];
                case 1:
                    _d = _f.sent(), status = _d.status, data = _d.data;
                    _e = status;
                    switch (_e) {
                        case 202: return [3 /*break*/, 2];
                        case 400: return [3 /*break*/, 5];
                        case 401: return [3 /*break*/, 5];
                        case 403: return [3 /*break*/, 5];
                        case 500: return [3 /*break*/, 5];
                        case 502: return [3 /*break*/, 8];
                        case 504: return [3 /*break*/, 8];
                    }
                    return [3 /*break*/, 9];
                case 2:
                    if (!enableValidation) return [3 /*break*/, 4];
                    return [4 /*yield*/, import(
                        /* webpackChunkName: "validate-nodes-bulk-approve-and-unenroll-response" */ '../../../validators/nodes-bulk-approve-and-unenroll-response')];
                case 3:
                    validateNodesBulkApproveAndUnenrollResponse = (_f.sent()).default;
                    if (!validateNodesBulkApproveAndUnenrollResponse(data)) {
                        throw new ValidationError(formatValidationError('validateNodesBulkApproveAndUnenrollResponse', validateNodesBulkApproveAndUnenrollResponse.errors, data));
                    }
                    _f.label = 4;
                case 4: return [2 /*return*/, { data: data, status: status }];
                case 5:
                    if (!enableValidation) return [3 /*break*/, 7];
                    return [4 /*yield*/, import(/* webpackChunkName: "validate-error-response" */ '../../../validators/error-response')];
                case 6:
                    validateErrorResponse = (_f.sent()).default;
                    if (!validateErrorResponse(data)) {
                        throw new ValidationError(formatValidationError('validateErrorResponse', validateErrorResponse.errors, data));
                    }
                    _f.label = 7;
                case 7: return [2 /*return*/, { data: data, status: status }];
                case 8: return [2 /*return*/, { data: data, status: status }];
                case 9: throw new ValidationError("'".concat(status, "' status is unexpected for this endpoint"));
            }
        });
    });
}
